import dayjs from 'dayjs';

export const isPastTime = (time: string): boolean => {
    const targetTime = dayjs(`${dayjs().format('YYYY-MM-DD')} ${time}`);
    return dayjs().isAfter(targetTime);
};
